export { default } from './AlertModal';
export { default as AlertModal } from './AlertModal';
